import { useMemo } from "react";
import { Row, Col } from "reactstrap";
import { DonutChart } from "../../../components/ApexChart";

const NeedsAttentionCard = ({ data = {}, t, isFetching }) => {
  const categories = useMemo(() => {
    const items = [
      {
        title: t("Legal Entities Without TOM"),
        amount: Number(data?.legal_entities_without_tom_count || 0),
      },
      {
        title: t("Revision Overdue"),
        amount: Number(data?.revision_overdue_count || 0),
      },
      {
        title: t("Revision Due Soon"),
        amount: Number(data?.revision_due_soon_count || 0),
      },
      {
        title: t("Unassigned"),
        amount: Number(data?.unassigned_count || 0),
      },
    ];

    const total = items.reduce((sum, item) => sum + item.amount, 0);

    return items.map((item) => ({
      title: item.title,
      amount: item.amount,
      percent: total > 0 ? Math.round((item.amount / total) * 100) : 0,
    }));
  }, [data, t]);

  if (isFetching) {
    return (
      <div
        className="dt-field dt-skeleton"
        style={{ width: "100%", height: "300px" }}
      />
    );
  }

  return (
    <Row>
      <Col lg={12}>
        <DonutChart title={t("Needs Attention")} categories={categories} />
      </Col>
    </Row>
  );
};

export default NeedsAttentionCard;
